<template lang="pug">
    v-row.mt-n1
        v-col(cols="12")
            label(for="title") Title
            v-text-field(
                id="title"
                v-model="titleComputed"
                type="text"
                outlined
                dense
                :disabled="readOnly"
                :rules="[v => !!v || 'Field is required']"
            )
        v-col(v-if="[ServiceRequestType.Ooo, ServiceRequestType.Vacation].includes(requestType)" cols="12" sm="12").mt-n7
            label(for="assigned") Requester
            v-autocomplete(
                id="assigned"
                v-model="assignedToComputed"
                outlined
                dense
                :readonly="!hasPermission(['manage-vacation'])"
                :disabled="readOnly"
                :rules="[v => !!v || 'Field is required']"
                :items="getAdUsersByRole([])"
                item-text="email"
                item-value="email"
            )
        v-col(
            v-if="[ServiceRequestType.Ooo, ServiceRequestType.Training].includes(requestType)"
            cols="12"
            sm="6"
            ).mt-n7
            label(for="date_range") Start Date
            datetime(
                type="datetime",
                zone="utc",
                :disabled="readOnly"
                :min-datetime="minDateForStartDate"
                :max-datetime="endDateRangeForOOORequest"
                v-model="startDateRangeForOOORequest"
                class="text-field-date"
                hide-details
                range
              )
        v-col(
            v-if="[ServiceRequestType.Ooo, ServiceRequestType.Training].includes(requestType)"
            cols="12"
            sm="6"
            ).mt-n7
            label(for="date_range") End Date
            datetime(
                type="datetime",
                zone="utc",
                :disabled="readOnly"
                :min-datetime="startDateRangeForOOORequest"
                :max-datetime="maxDateForEndDate"
                v-model="endDateRangeForOOORequest"
                class="text-field-date"
                hide-details
                range
              )
        v-col(
            v-if="![ServiceRequestType.Ooo, ServiceRequestType.Training].includes(requestType)"
            cols="12"
            :sm="[ServiceRequestType.Holiday, ServiceRequestType.Internal].includes(requestType) ? 12 : 6"
            ).mt-n7
            label(for="date_range") Date Period
            v-dialog(
                ref="dateRangeModalDialog"
                v-model="dateRangeModal"
                :return-value.sync="selectedRange"
                persistent
                width="290px"
              )
                template(v-slot:activator="{ on, attrs }")
                    v-text-field(
                        v-model="dateRangeComputedDisplayText"
                        id="date_range"
                        readonly
                        outlined
                        dense
                        :disabled="readOnly"
                        v-bind="attrs"
                        v-on="on"
                        :rules="[v => !!v || 'Field is required']"
                        )
                v-date-picker(
                        v-model="selectedRange"
                        scrollable
                        range
                        :min="minSelectableDate"
                        )
                    v-spacer
                    v-btn(
                        text
                        color="primary"
                        @click="dateRangeModal = false"
                        ) Cancel 
                    v-btn(
                        text
                        color="primary"
                        @click="$refs.dateRangeModalDialog.save(selectedRange)"
                        ) Ok
        v-col(v-if="requestType === ServiceRequestType.Training" cols="12" sm="12")
            label(for="status") Status
            v-autocomplete(
                id="status"
                v-model="statusComputed"
                outlined
                dense
                :disabled="readOnly"
                :items="statusOptions"
              )
        v-col(
          v-if="[ServiceRequestType.Vacation].includes(requestType)"
          cols="12"
          :sm="[ServiceRequestType.Holiday, ServiceRequestType.Internal].includes(requestType) ? 12 : 6"
          ).mt-n7
            label(for="totalHours") Total Vacation Hours
            v-text-field(
              v-model="hoursComputed"
              id="totalHours"
              outlined
              :disabled="readOnly"
              type="number"
              dense
              )
        v-col(v-if="requestType === ServiceRequestType.Training && statusComputed === ServiceRequestStatus.Completed" cols="12" sm="12").mt-n7
            label(for="assigned") Participants
            v-autocomplete(
                id="assigned"
                v-model="assignedToComputed"
                outlined
                dense
                multiple
                :disabled="readOnly"
                :rules="[v => !!v && v.length > 0  || 'Field is required']"
                :items="getAdUsersByRole([])"
                item-text="email"
                item-value="email"
            )
</template>

<script>
import { ServiceRequestStatus, ServiceRequestType } from "@/graphql/jarvis";
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  props: {
    requestType: {
      type: String || null,
      default: null,
    },
    requestStatus: {
      type: String || null,
      default: null,
    },
    title: {
      type: String || null,
      default: null,
    },
    hours: {
      type: Number || null,
      default: null,
    },
    type: {
      type: String || null,
      default: null,
    },
    assignedTo: {
      type: Array,
      default: null,
    },
    startDate: {
      type: String || null,
      default: null,
    },
    endDate: {
      type: String || null,
      default: null,
    },
  },
  watch: {
    selectedRange: {
      deep: true,
      handler(v) {
        this.$emit("update:startDate", v?.[0]);
        this.$emit("update:endDate", v?.[1]);
      },
    },
  },
  methods: {
    // autoSetHours() {
    //   if ([ServiceRequestType.Vacation].includes(this.requestType)) {
    //     const startDate = this.startDate;
    //     const endDate = this.endDate;
    //     if (!startDate || !endDate) return;
    //     const workHours = 8;
    //     const totalDaysOff =
    //       moment.utc(endDate).diff(moment.utc(startDate), "days") + 1;
    //     const hours = totalDaysOff * workHours;
    //     this.$emit("update:hours", hours);
    //   }
    // },
    autoSetRequesterForVacationRequest() {
      if (
        [ServiceRequestType.Ooo, ServiceRequestType.Vacation].includes(
          this.requestType
        ) &&
        this.type === "create"
      ) {
        this.$emit("update:assignedTo", [this.userEmail]);
      }
    },
  },
  computed: {
    ...mapGetters("adUsers", ["getAdUsersByRole"]),
    maxDateForEndDate() {
      if (this.requestType === ServiceRequestType.Ooo) {
        if (this.startDateRangeForOOORequest) return moment.utc(this.startDateRangeForOOORequest).endOf('d').format()
        return null
      }
      return null
    },
    minDateForStartDate() {
      if (this.requestType === ServiceRequestType.Ooo) {
        if (this.endDateRangeForOOORequest) return moment.utc(this.endDateRangeForOOORequest).startOf('d').format()
        return null
      }
      return null
    },
    readOnly() {
      if (this.type === "create") return false;
      if (
        [ServiceRequestType.Ooo, ServiceRequestType.Vacation].includes(
          this.requestType
        )
      ) {
        if (
          !(this.assignedTo || []).includes(this.userEmail) &&
          !this.hasPermission(["manage-vacation"])
        ) {
          return true;
        }

        if (
          this.requestStatus === ServiceRequestStatus.Approved &&
          !this.hasPermission(["manage-vacation"])
        ) {
          return true;
        }
      } else if (this.requestType === ServiceRequestType.Internal) {
        if (!this.hasPermission(["manage-internal-meeting"])) {
          return true;
        }
      } else if (this.requestType === ServiceRequestType.Training) {
        if (!this.hasPermission(["manage-training"])) {
          return true;
        }
      } else {
        if (!this.hasPermission(["manage-holiday-stats"])) {
          return true;
        }
      }
      return false;
    },
    minSelectableDate() {
      return !this.hasPermission(["manage-vacation"])
        ? moment.utc().add(1, "d").toISOString()
        : null;
    },
    userEmail() {
      return this.$store.state?.auth?.userContext?.email;
    },
    titleComputed: {
      get() {
        return this.title;
      },
      set(v) {
        this.$emit("update:title", v);
      },
    },
    hoursComputed: {
      get() {
        return this.hours;
      },
      set(v) {
        this.$emit("update:hours", v);
      },
    },
    statusComputed: {
      get() {
        return this.requestStatus;
      },
      set(v) {
        if (
          this.requestType === ServiceRequestType.Training &&
          v === ServiceRequestStatus.Planned
        ) {
          this.$emit("update:assignedTo", []);
        }
        this.$emit("update:requestStatus", v);
      },
    },
    assignedToComputed: {
      get() {
        return [ServiceRequestType.Ooo, ServiceRequestType.Vacation].includes(
          this.requestType
        )
          ? this.assignedTo?.[0]
          : this.assignedTo;
      },
      set(v) {
        this.$emit("update:assignedTo", Array.isArray(v) ? v : [v]);
      },
    },
    dateRangeComputedDisplayText: {
      get() {
        if (this.selectedRange.length !== 2) return "";
        return `${moment
          .utc(this.selectedRange[0])
          .format("DD MMM YYYY")} - ${moment
            .utc(this.selectedRange[1])
            .format("DD MMM YYYY")}`;
      },
      set(v) {
        //
      },
    },
    startDateRangeForOOORequest: {
      get() {
        return this.startDate;
      },
      set(v) {
        this.$emit("update:startDate", v);
      },
    },
    endDateRangeForOOORequest: {
      get() {
        return this.endDate;
      },
      set(v) {
        this.$emit("update:endDate", v);
      },
    },
  },
  data() {
    return {
      ServiceRequestStatus: ServiceRequestStatus,
      statusOptions: [
        ServiceRequestStatus.Planned,
        ServiceRequestStatus.Completed,
      ],
      selectedRange:
        this.startDate && this.endDate
          ? [
            moment.utc(this.startDate).format("YYYY-MM-DD"),
            moment.utc(this.endDate).format("YYYY-MM-DD"),
          ]
          : [],
      dateRangeModal: false,
      ServiceRequestType: ServiceRequestType,
      form: {},
    };
  },
  mounted() {
    this.autoSetRequesterForVacationRequest();
  },
};
</script>
